import React, { Component } from 'react'

import './PopupAlerteVeille.css'

function PopupAlerteVeille({duree_affichage}) {

  return (
    <div className="alerte-veille-overlay" >
      <JaugeCirculaire
          className="alerte-veille-canvas"
          time={duree_affichage}
          size={500}
          lineWidth={12}
          backColor="transparent"
          frontColor="#FFF" />

      <div className="alerte-veille">
        L'application va bientôt se mettre en veille.
        Touchez l'écran pour continuer la consultation.
      </div>
    </div>
  );
}




class JaugeCirculaire extends Component {

  constructor(props) {
    
    super(props);

    this.interval = null;
    this.raf = null;
    this.arc_background = null;
    this.ctx = null;
    this.size = null;
    this.startTime = null;
    
    this.state = {
      time: props.time
    };
  }

  componentWillMount() {
    this.size = this.props.size || 256
  }

  componentDidMount() {
    //let halfSize = this.size / 2
    this.ctx = this.refs.canvas.getContext('2d')
    this.startTimer();
  }

  startTimer = () => {
    this.startTime = performance.now()
    this.interval = setInterval(()=>{
      var time = this.state.time - 1
      if (time > 0) {
        this.setState({time});
      }
      else{
        this.setState({time:0});
        if (typeof this.props.onFinished !== "undefined") this.props.onFinished()
        clearInterval(this.interval)
      }
    }, 1000)
    this.draw()
  }

  componentWillUnmount() {
    clearInterval(this.interval)
    this.interval = null
    cancelAnimationFrame(this.raf)
    this.raf = null
  }

  draw = () => {
    if (!this.ctx) return;

    var {lineWidth, backColor, frontColor} = this.props
    lineWidth = lineWidth || 24
    frontColor = frontColor || "red"

    var temps_ecoule_ms = performance.now() - this.startTime
    var temps_total = this.props.time * 1000 // conversion en ms

    this.percentage = temps_ecoule_ms / (temps_total -  this.state.time  )

    let startAngle = 0
    let endAngle = (2*Math.PI ) * this.percentage


    let center = this.size/2
    let rayon = this.size/2 - lineWidth/2 // le stroke est "centré", a moitié dedans et dehors, alors on calcule le rayon

    this.ctx.clearRect(0, 0, this.size, this.size)
    this.ctx.lineWidth = lineWidth;

    this.ctx.beginPath()
    this.ctx.strokeStyle = backColor
    this.ctx.arc(center, center , rayon, 0, Math.PI*2)
    this.ctx.stroke()

    this.ctx.beginPath()
    this.ctx.strokeStyle = frontColor
    this.ctx.arc(center, center , rayon, startAngle, endAngle)
    this.ctx.stroke()

    if (this.percentage < 1) {
      this.raf = requestAnimationFrame(this.draw)
    }
  }


  render() {
    const {className, showTime, style} = this.props

    return (
      <div className={className} style={style}>
        <canvas ref="canvas" width={this.size} height={this.size}></canvas>
        { showTime && <div className={className + "-time"}>{this.state.time}s</div>}
      </div>
    )

  }
}


export default PopupAlerteVeille;


// WEBPACK FOOTER //
// ./src/PopupAlerteVeille.js